import { AreaChart, Area, BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Cell } from "recharts";

const tooltipStyle = { background: "#121212", border: "1px solid rgba(255,255,255,0.15)", borderRadius: 8, fontSize: 12, color: "#F3F4F6" };
const axis = { stroke: "rgba(255,255,255,0.2)", tick: { fill: "#6B7280", fontSize: 11, fontFamily: "JetBrains Mono" }, tickLine: false, axisLine: false };

export const EquityChart = ({ data, dataKey = "equity", height = 280 }) => (
  <ResponsiveContainer width="100%" height={height}>
    <AreaChart data={data} margin={{ top: 8, right: 8, left: 0, bottom: 0 }}>
      <defs>
        <linearGradient id="eqGrad" x1="0" y1="0" x2="0" y2="1">
          <stop offset="0%" stopColor="#00F0FF" stopOpacity={0.25} />
          <stop offset="100%" stopColor="#00F0FF" stopOpacity={0} />
        </linearGradient>
      </defs>
      <CartesianGrid stroke="rgba(255,255,255,0.05)" vertical={false} />
      <XAxis dataKey="date" {...axis} minTickGap={48} />
      <YAxis {...axis} width={70} tickFormatter={(v) => `$${(v / 1000).toFixed(0)}k`} domain={["auto", "auto"]} />
      <Tooltip contentStyle={tooltipStyle} formatter={(v) => [`$${Number(v).toLocaleString()}`, "Equity"]} />
      <Area type="monotone" dataKey={dataKey} stroke="#00F0FF" strokeWidth={1.8} fill="url(#eqGrad)" />
    </AreaChart>
  </ResponsiveContainer>
);

export const MonthlyBars = ({ data, dataKey = "return", unit = "%", height = 240 }) => (
  <ResponsiveContainer width="100%" height={height}>
    <BarChart data={data} margin={{ top: 8, right: 8, left: 0, bottom: 0 }}>
      <CartesianGrid stroke="rgba(255,255,255,0.05)" vertical={false} />
      <XAxis dataKey="month" {...axis} />
      <YAxis {...axis} width={50} tickFormatter={(v) => `${v}${unit === "%" ? "%" : ""}`} />
      <Tooltip contentStyle={tooltipStyle} formatter={(v) => [`${Number(v).toLocaleString()}${unit}`, dataKey]} cursor={{ fill: "rgba(255,255,255,0.04)" }} />
      <Bar dataKey={dataKey} radius={[4, 4, 0, 0]}>
        {data.map((d, i) => <Cell key={i} fill={d[dataKey] >= 0 ? "#00E676" : "#FF3B30"} fillOpacity={0.85} />)}
      </Bar>
    </BarChart>
  </ResponsiveContainer>
);

export const TradingViewWidget = ({ symbol = "OANDA:XAUUSD", height = 360 }) => (
  <iframe
    title="tradingview-chart"
    data-testid="tradingview-widget"
    src={`https://s.tradingview.com/widgetembed/?symbol=${encodeURIComponent(symbol)}&interval=60&theme=dark&style=1&locale=en&hide_top_toolbar=0&hide_legend=0&toolbarbg=121212`}
    style={{ width: "100%", height, border: 0, borderRadius: 8 }}
  />
);
